import React from 'react';
import MutedText from '../common/MutedText';

export default function TotpAppsList(): React.JSX.Element {
  return (
    <div className="fe_u_text-align--left fe_u_font-size--default fe_u_font-weight--semibold fe_u_color--muted">
      <ul className="unordered-list">
        <li className="fe_u_font-size--default fe_u_padding--top-xsmall">
          Google Authenticator
        </li>
        <li className="fe_u_font-size--default fe_u_padding--top-xsmall">
          Microsoft Authenticator
        </li>
        <li className="fe_u_font-size--default fe_u_padding--top-xsmall">
          Duo Mobile
        </li>
      </ul>
      <div className='fe_c_heading--subsection__description'>
        <MutedText
          className='fe_u_text-align--left fe_u_font-size--default'
          text='Open the app on your mobile device and scan the QR code below to add your account:'
        />
      </div>
    </div>
  );
}
